<!-- 页面内容 -->

<template>
    <div class='content'>
        <el-pagination :layout="layout" :current-page="page" :page-size="pageSize" :total="total"
            @current-change="pageChange" @size-change="pageSizeChange" />
    </div>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
            default: 0
        },
        pageSize: {
            type: Number,
            default: 4
        },
        page: {
            type: Number,
            default: 1
        },
        layout: {
            type: String,
            default: "prev, pager, next"
        }
    },
    methods: {
        pageChange(page) {
            this.$emit('update:page', page);
            this.$emit('change');
        },
        pageSizeChange(size) {
            this.$emit('update:pageSize', size);
            this.$emit('change');
        }
    },
}
</script>

<style lang='scss' scoped>
/* 假设你想要替换上一页和下一页的图标 */
::v-deep .el-pager li {
    background: #F5F5F5 !important;
}

::v-deep .btn-prev {
    border-radius: 50% !important;
    /* 使用背景图片或字体图标来替换默认图标 */
    background-image: url('../assets/images3/9.png');
    /* 或者使用字体图标 */
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto !important;
    width: 48px;
    height: 48px;
    /* 其他样式，如宽度、高度、边框等 */
}

::v-deep .el-icon-arrow-left:before {
    content: none !important;
}

::v-deep .el-icon-arrow-right:before {
    content: none !important;
}

::v-deep .el-pager li.active {
    color: #B18148 !important;
}

::v-deep .el-pagination {
    display: flex;
    align-items: center;
}

::v-deep .btn-next {
    border-radius: 50% !important;
    width: 48px;
    height: 48px;
    background-size: auto !important;
    /* 使用背景图片或字体图标来替换默认图标 */
    background-image: url('../assets/images3/10.png');
    /* 或者使用字体图标 */
    background-position: center;
    background-repeat: no-repeat;
    /* 其他样式，如宽度、高度、边框等 */
}
</style>
